export default __webpack_public_path__ + "b47a96337686c1b924970bc295c896f2.png";